// extracted by css-extract-rspack-plugin
export default {"toneLight":"_a6d6fe81","toneDark":"_6b5593e3"};